import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
//import AgregarSolicitudInterna from './AgregarSolicitudInterna';
//import ModificarSolicitudInterna from './ModificarSolicitudInterna';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from "xlsx";
import { FaFileExcel } from "react-icons/fa";
import {getCurrentDate,urlApiProd,eliminarDiacriticosEs,print} from '../utiles';
import moment from 'moment';
import { Modal, Button, Spinner, Badge } from 'react-bootstrap';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const handleRowClicked = row => {
    print(`Row clicked:`, row);
  };

const CargarTasas = ({ solicitudes, solicitudesInternas, puertos, ffw, carriers, cerrar }) => {
    const [formData, setFormData] = useState({
        fecha_creacion: '',
                        ffw: '',
                        armador: '',
                        pol : '',
                        pod: '',
                        frete: '',
                        freetime_origen: '',
                        freetime_destino: '',
                        validade: '',
                        transittimi: '',
    });
    const [cantidadMaxima, setCantidadMaxima] = useState(null);
    const [solicitudInterna, setSolicitudInterna] = useState(null);
    const [pedidoCompletado, setPedidoCompletado] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [filterMonth, setFilterMonth] = useState('');
    const [filterYear, setFilterYear] = useState('');
    const [filterEstado, setFilterEstado] = useState('');
    const [dataTasas, setDataTasas] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [apoyo, setApoyo] = useState(undefined);
    const [principal, setPrincipal] = useState(undefined);
    const firstRender = useRef(true);
    const [showAgregar, setShowAgregar] = useState(false);
    const [show, setShow] = React.useState(true);
    const [loading, setLoading] = useState(true);
    
        const handleClose = () => {setShow(false);
            cerrar();
        };

        useEffect(() => {
                    if (firstRender.current) {
                        setLoading(true);
                        fetchData();
                        firstRender.current = false;
                    }
                }, []);

    const fetchData = async (page = currentPage, rowsPerPage = perPage) => {
        const token = localStorage.getItem('token');
        try {
            // Fetch Solicitudes Internas
            const responseTasas = await fetch(`${urlApiProd}/preciostasas`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!responseTasas.ok) throw new Error('Error fetching Tasas');
            const data = await responseTasas.json();
            setDataTasas(data);
           // setTotalItems(total);
        } catch (error) {
            console.error('Error en fetchData:', error.message);
            setPrincipal(false); // Indica que la solicitud principal falló
            toast.error(`Tasas no cargados: ${error.message}`, { toastId: 'error-principal' });
        } finally{
            setLoading(false);
        }
    };

    useEffect(() => {
        print('Filtrando con:', { filterText, filterMonth, filterYear });
        const filtered = Array.isArray(dataTasas)
            ? dataTasas.filter(precioTasas => {
                const matchesMonth = filterMonth
                    ? new Date(precioTasas.fecha_creacion).getUTCMonth() + 1 === parseInt(filterMonth)
                    : true;
                const matchesYear = filterYear
                    ? new Date(precioTasas.fecha_creacion).getUTCFullYear() === parseInt(filterYear)
                    : true;

                return matchesMonth && matchesYear;
            })
            : [];
        setFilteredData(filtered);
    }, [dataTasas, filterText, filterEstado, filterMonth, filterYear]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChangeUpperCase = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };

    const handleChangeLimited = (e, max) => {
        const { name, value } = e.target;
        const numericValue = parseInt(value, 10);
    
        if (isNaN(numericValue) || numericValue <= 0) {
            alert('Por favor, ingrese un número válido mayor a 0.');
            return;
        }
    
        if (numericValue <= max) {
            setFormData({ ...formData, [name]: numericValue });
        } else {
            alert(`El valor máximo permitido es ${max} días.`);
        }
    };

    const columns = [
        {
            name: 'Origen',
            selector: row => puertos.find(puerto => puerto.id_puerto === row.puerto_origen)?.nombre || '',  sortable: true
        },
        {
            name: 'Carrier',
            selector: row => carriers.find(carrier => carrier.id_carrier === row.armador)?.nombre || '',  sortable: true
        },
        {
            name: 'FFW',
            selector: row => row.ffw!=-1 ? ffw.find(ffw => ffw.id_ffw === row.ffw)?.nombre : '',  sortable: true
        },
 
        { name: 'thc_cntr', selector: row => row.thc_cntr,  sortable: true },
        { name: 'express_release_bl', selector: row => row.express_release_bl, sortable: true},
        { name: 'ispsbrs_cntr', selector: row => row.ispsbrs_cntr, sortable: true },
        { name: 'elf_cntr', selector: row => row.elf_cntr, sortable: true },
        { name: 'cmf_cntr', selector: row => row.cmf_cntr, sortable: true },
        { name: 'lacre_cntr', selector: row => row.lacre_cntr, sortable: true },
        { name: 'blfeers_bl', selector: row => row.blfeers_bl, sortable: true},
        { name: 'expfee_cntr', selector: row => row.expfee_cntr, sortable: true},

        { name: 'cntrrelease_cntr', selector: row => row.cntrrelease_cntr,  sortable: true },
        { name: 'abroadfee_bl', selector: row => row.abroadfee_bl, sortable: true},
        { name: 'psc_cntr', selector: row => row.psc_cntr, sortable: true },
        { name: 'kls_cntr', selector: row => row.kls_cntr, sortable: true },
        { name: 'blfeeusd_bl', selector: row => row.blfeeusd_bl, sortable: true},
        { name: 'tsc_cntr', selector: row => row.tsc_cntr, sortable: true},

        { name: 'imo_cntr', selector: row => row.imo_cntr,  sortable: true },
        { name: 'lacreusb_cntr', selector: row => row.lacreusb_cntr, sortable: true},
        { name: 'isps_cntr', selector: row => row.isps_cntr, sortable: true },
        { name: 'ams_bl', selector: row => row.ams_bl, sortable: true },
        { name: 'handling_cntr', selector: row => row.handling_cntr, sortable: true},


        { name: 'Acciones',
                    cell: row => (
                        <div>
                                <button
                                    className='btn btn-outline-danger'
                                    onClick={() => {
                                        if (window.confirm('¿Estás seguro de eliminar este precio de tasa?')) {
                                            handleEliminar(row.id);
                                        }
                                    }}
                                >
                                    <IoTrashOutline />
                                </button>
                        </div>
                    ),
                    ignoreRowClick: true,
                }
    ];

    const handleChangeSolicitudInterna = (e) => {
        const { name, value } = e.target;
        const solicitud_interna = solicitudesInternas.find((solicitud) => solicitud.id_solicitudinterna === parseInt(value, 10));
        if(solicitud_interna){
            setSolicitudInterna(solicitud_interna);
            const solicitudesAsociadas = solicitudes.filter((solicitud) => solicitud.solicitud_interna.id === solicitud_interna.id_solicitudinterna);
            setCantidadMaxima(solicitud_interna.cantidad - (solicitudesAsociadas.reduce((acc, solicitud) => acc + solicitud.cantidad, 0)));
            setFormData({ ...formData, [name]: value, etd: solicitud_interna.etd, id_puerto_destino: solicitud_interna.id_puerto_destino });
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
    };


    const handleChangeCantidad = (e) => {
        const { name, value } = e.target;
        if(solicitudInterna && cantidadMaxima){
            if(parseInt(value, 10) <= cantidadMaxima){
                setFormData({ ...formData, [name]: value });
                if(cantidadMaxima - parseInt(value, 10) === 0){
                    setPedidoCompletado(true);
                }
                if(cantidadMaxima - parseInt(value, 10) > 0){
                    setPedidoCompletado(false);
                }
            } else {
                alert(`La cantidad máxima permitida es ${cantidadMaxima}`);
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    }

    function getJsDateFromExcel(excelDate) {

        // JavaScript dates can be constructed by passing milliseconds
        // since the Unix epoch (January 1, 1970) example: new Date(12312512312);
      
        // 1. Subtract number of days between Jan 1, 1900 and Jan 1, 1970, plus 1 (Google "excel leap year bug")             
        // 2. Convert to milliseconds.
      
          return new Date((excelDate - (25567 + 1))*86400*1000);
      
      }

      const handleEliminar = async (id) => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/deletepreciotasa/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Error eliminando precio tasa');
            alert('Precio tasa eliminada exitosamente');
            fetchData();
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo eliminar precio tasa');
        }
    };

    const handleAgregarTasas = () => setShowAgregar(true);

    const handleUpload = async (e) => {
        print('reading input file:');
        const file = e.target.files[0];
        const data = await file.arrayBuffer();
        setLoading(true);
        const workbook = XLSX.read(data);
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            defval: "",
        });

        //var cleanjsonData = jsonData.filter((arr, index, self) => index === self.findIndex((t) => (t.save === arr.save && t.State === arr.State)))
       //var cleanjsonData = jsonData;
        var cleanjsonData = Array.from(new Set(jsonData.map(JSON.stringify))).map(JSON.parse);

        var registrosError = [];
        var registrosExistentes = [];
        var listaYaAgregados = [];
        var registrosExpirar = [];

        var error = false;
        //procesar cada fila
        if(cleanjsonData[0][0]==='PUERTO'){
        for(var k in cleanjsonData) {
            //print(jsonData[k][0]);

            if(cleanjsonData[k][0]==='PUERTO'){} else{
              
                let fecha_validade = moment(getJsDateFromExcel(cleanjsonData[k][7]));
                let converted_date = fecha_validade.format('YYYY-MM-DD');
                //let converted_date = new Date(Math.round((jsonData[k][7] - 25569) * 864e5));
                //converted_date = moment(converted_date).format('YYYY-MM-DD');

                var id_ffw =  ffw.find(ffw => eliminarDiacriticosEs(ffw.nombre.toUpperCase().trim())===eliminarDiacriticosEs(cleanjsonData[k][2].toUpperCase().trim()))?.id_ffw || -2;
                var id_carrier = carriers.find(carrier => eliminarDiacriticosEs(carrier.nombre.toUpperCase().trim())===eliminarDiacriticosEs(cleanjsonData[k][1].toUpperCase().trim()))?.id_carrier || -2;
                var id_puerto_origen = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase().trim())===eliminarDiacriticosEs(cleanjsonData[k][0].toUpperCase().trim()) || eliminarDiacriticosEs(puerto.nombre.toUpperCase().trim())===eliminarDiacriticosEs(cleanjsonData[k][0].toUpperCase().trim()))?.id_puerto || -2;



                var precioTasaRaw = { 
                    ffw: id_ffw,
                    armador: id_carrier,
                    puerto_origen : id_puerto_origen,

                    thc_cntr : cleanjsonData[k][3]==="" ? 0 : cleanjsonData[k][3],
                    express_release_bl : cleanjsonData[k][4]==="" ? 0 : cleanjsonData[k][4],
                    ispsbrs_cntr : cleanjsonData[k][5]==="" ? 0 : cleanjsonData[k][5],
                    elf_cntr : cleanjsonData[k][6]==="" ? 0 : cleanjsonData[k][6],

                    cmf_cntr : cleanjsonData[k][7]==="" ? 0 : cleanjsonData[k][7],
                    lacre_cntr : cleanjsonData[k][8]==="" ? 0 : cleanjsonData[k][8],

                    blfeers_bl : cleanjsonData[k][9]==="" ? 0 : cleanjsonData[k][9],
                    expfee_cntr : cleanjsonData[k][10]==="" ? 0 : cleanjsonData[k][10],
                    cntrrelease_cntr : cleanjsonData[k][11]==="" ? 0 : cleanjsonData[k][11],
                    abroadfee_bl : cleanjsonData[k][12]==="" ? 0 : cleanjsonData[k][12],
                    psc_cntr : cleanjsonData[k][13]==="" ? 0 : cleanjsonData[k][13],
                    kls_cntr : cleanjsonData[k][14]==="" ? 0 : cleanjsonData[k][14],
                    blfeeusd_bl : cleanjsonData[k][15]==="" ? 0 : cleanjsonData[k][15],
                    tsc_cntr : cleanjsonData[k][16]==="" ? 0 : cleanjsonData[k][16],
                    imo_cntr : cleanjsonData[k][17]==="" ? 0 : cleanjsonData[k][17],
                    lacreusb_cntr : cleanjsonData[k][18]==="" ? 0 : cleanjsonData[k][18],
                    isps_cntr : cleanjsonData[k][19]==="" ? 0 : cleanjsonData[k][19],
                    ams_bl : cleanjsonData[k][20]==="" ? 0 : cleanjsonData[k][20],
                    handling_cntr : cleanjsonData[k][21]==="" ? 0 : cleanjsonData[k][21],
                    fecha_creacion : getCurrentDate(),
                    fecha_expira : '2100-01-01',
                };

                print(`id_ffw ${id_ffw} id_carrier ${id_carrier} id_puerto_origen ${id_puerto_origen}`);

//si registro existe igual no se considera.
//si registro existe con diferentes valores de tasa se actualiza y se deja anterior como expirado (fecha)


                if(id_carrier===-2 || id_puerto_origen===-2 || id_ffw===-2 ){ // || moment()>fecha_validade

                    registrosError.push(`fila ${parseInt(k)+1} data: ${cleanjsonData[k]}\n`);
                } else if(dataTasas.findIndex(pt => pt.ffw===id_ffw && pt.armador===id_carrier && pt.puerto_origen===id_puerto_origen && pt.thc_cntr==precioTasaRaw.thc_cntr && precioTasaRaw.express_release_bl === pt.express_release_bl && precioTasaRaw.ispsbrs_cntr === pt.ispsbrs_cntr && precioTasaRaw.elf_cntr === pt.elf_cntr && precioTasaRaw.cmf_cntr === pt.cmf_cntr && precioTasaRaw.lacre_cntr === pt.lacre_cntr && precioTasaRaw.blfeers_bl === pt.blfeers_bl && precioTasaRaw.expfee_cntr === pt.expfee_cntr && precioTasaRaw.cntrrelease_cntr === pt.cntrrelease_cntr && precioTasaRaw.abroadfee_bl === pt.abroadfee_bl && precioTasaRaw.psc_cntr === pt.psc_cntr && precioTasaRaw.kls_cntr === pt.kls_cntr && precioTasaRaw.blfeeusd_bl === pt.blfeeusd_bl && precioTasaRaw.tsc_cntr === pt.tsc_cntr && precioTasaRaw.imo_cntr === pt.imo_cntr && precioTasaRaw.lacreusb_cntr === pt.lacreusb_cntr && precioTasaRaw.isps_cntr === pt.isps_cntr && precioTasaRaw.ams_bl === pt.ams_bl && precioTasaRaw.handling_cntr === pt.handling_cntr
                )!==-1){ //  && precioTasas.validade===converted_date
                    registrosExistentes.push(`fila ${parseInt(k)+1} data: ${cleanjsonData[k]}\n`);   
                    print(`registrosExistentes ${registrosExistentes.length}`);
                    registrosExpirar.push(precioTasaRaw);

                } else if(listaYaAgregados.findIndex(pt => pt.ffw===id_ffw && pt.armador===id_carrier && pt.puerto_origen===id_puerto_origen)!==-1){
                    registrosExistentes.push(`fila ${parseInt(k)+1} duplicado: ${cleanjsonData[k]}\n`);   
                    print(`registrosExistentes duplicado ${registrosExistentes.length}`);
                }
                //en vez de hacer else if agregarlo al else 
                else {

                    listaYaAgregados.push(precioTasaRaw);

                    if(registrosExpirar.findIndex(pt => pt.ffw===id_ffw && pt.armador===id_carrier && pt.puerto_origen===id_puerto_origen)!==-1 && dataTasas.findIndex(pt => pt.ffw===id_ffw && pt.armador===id_carrier && pt.puerto_origen===id_puerto_origen)!==-1){
                        var elementoExpirar = dataTasas.find(pt => pt.ffw===id_ffw && pt.armador===id_carrier && pt.puerto_origen===id_puerto_origen); 
                        elementoExpirar.fecha_expira= getCurrentDate();
                        const token = localStorage.getItem('token');
                         try {
                          const response = await fetch(`${urlApiProd}/editpreciotasa/${elementoExpirar.id}`, {
                           method: 'PUT',
                           headers: {
                            'Content-Type': 'application/json',
                             'Authorization': `Bearer ${token}`
                               },
                               body: JSON.stringify(elementoExpirar)
                                });
                          if (response.ok){ 
                              print(`elementoExpirar listo ${elementoExpirar.fecha_expira}`);
                           } else{
                              print(`elementoExpirar FALLO ${elementoExpirar.fecha_expira} ,, ${elementoExpirar}`);
                           }
                                      
  
                   } catch (error) {
                      print(`elementoExpirar error ${error}`);
                     }
                  }

                    print(cleanjsonData[k]);
                   

                    const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${urlApiProd}/addpreciostasas`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(precioTasaRaw)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al agregar precio de tasa');
                print(`Error al agregar precio de tasa ${precioTasaRaw.fecha_creacion}`); 
            } else{
                print(`addpreciostasas listo ${precioTasaRaw.fecha_creacion}`); 
            }
            //else alert('Precio de tasa agregado exitosamente');
            /*
            if(pedidoCompletado && response.ok){
                const responseSolicitudInterna = await fetch(`https://api.dvstarlab.com/editsolicitudinterna/${solicitudInterna.id_solicitudinterna}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ ...solicitudInterna, estado: 1 })
                });
                if (!responseSolicitudInterna.ok) {
                    const errorData = await responseSolicitudInterna.json();
                    throw new Error(errorData.error || 'Error al editar la solicitud interna');
                }
                alert('Solicitud Interna completada exitosamente');
            }else if(pedidoCompletado && !response.ok){
                alert('No se pudo completar la solicitud interna modificar manualmente');
            }
            cerrar();
            */
        } catch (error) {
            console.error('Error:', error);
            error=true;
        }

                }
        }
         }
         if(error){
            alert('No se pudo agregar tasas');
         }

         fetchData();

         if(registrosError.length>0 || registrosExistentes.length>0){
            var error = registrosError.length>0 ? `Existen ${registrosError.length} registros con error, favor revisar y volver a cargar.\n ${registrosError}\n` : '';

            var existen = registrosExistentes.length>0 ? `Existen ${registrosExistentes.length} registros ya existentes, favor revisar y volver a cargar.\n ${registrosExistentes}` : '';

            alert(`${error}${existen}`);
         }
        } else{
            setLoading(false);
            alert(`Favor validar archivo seleccionado`);  
        }
    
        //print(e.target.files[0]);
        //print(workbook);
        
    }

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="my-modal" size='xl' backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Tasas</Modal.Title>
              </Modal.Header>
              <Modal.Body>{loading ? (
                                                      <div className="text-center">
                                                          <Spinner animation="border" role="status" />
                                                          <span className="sr-only">Cargando...</span>
                                                      </div>
                                                  ) : (<div>
              <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                paginationPerPage={10}
                                onChangePage={handlePageChange}
                                highlightOnHover
                                responsive
                            />


                    Cargar tasas desde archivo<br></br>               
                    <input id="fileUpload" type="file" onInput={(e) => {handleUpload(e); e.target.value = null;} } />

                    </div>  )}
              </Modal.Body>
            </Modal>
    );
};

export default CargarTasas;
